import React from 'react';
import { formatDecimals, formatNumber } from '../../../utils';
import { Flexbox, FlexboxColumn } from '../../action/Flexbox';
import DualProgressBar from '../../DualProgressbar/DualProgressbar';
import ThemedText from '../../theme/ThemedText';

function ProtocolVoting({ postData }) {
  switch (postData?.protocol) {
    case 'kaito':
      return (
        <>
          <DualProgressBar
            leftValue={postData?.kaitoData?.likeAirdropSum}
            rightValue={postData?.kaitoData?.dislikeAirdropSum}
            rightContent={`$${formatNumber(formatDecimals(postData?.kaitoData?.dislikeAirdropSum))}`}
            leftContent={`$${formatNumber(formatDecimals(postData?.kaitoData?.likeAirdropSum))}`}
            leftLabel='Airdrop Claimed'
            rightLabel='Airdrop Claimed'
          />
          <DualProgressBar
            leftValue={postData?.kaitoData?.likeGenesisHoldersCount || 0}
            rightValue={postData?.kaitoData?.dislikeGenesisHoldersCount || 0}
            rightContent={postData?.kaitoData?.dislikeGenesisHoldersCount || 0}
            leftContent={postData?.kaitoData?.likeGenesisHoldersCount || 0}
            leftLabel='Kaito NFT Holders'
            rightLabel='Kaito NFT Holders'
          />
          <DualProgressBar
            leftValue={postData?.kaitoData?.likeStakedSum}
            rightValue={postData?.kaitoData?.dislikeStakedSum}
            rightContent={`${formatNumber(formatDecimals(postData?.kaitoData?.dislikeStakedSum))}`}
            leftContent={`${formatNumber(formatDecimals(postData?.kaitoData?.likeStakedSum))}`}
            leftLabel='$KAITO Staked'
            rightLabel='$KAITO Staked'
          />
        </>
      );
    case 'layer3':
      return (
        <>
          <DualProgressBar
            leftValue={formatDecimals(postData?.layer3Data?.likeCubesMintedSum || 0)}
            rightValue={formatDecimals(postData?.layer3Data?.dislikeCubesMintedSum || 0)}
            rightContent={`${formatNumber(postData?.layer3Data?.dislikeCubesMintedSum || 0)}`}
            leftContent={`${formatNumber(postData?.layer3Data?.likeCubesMintedSum || 0)}`}
            leftLabel='Cubes Minted'
            rightLabel='Cubes Minted'
          />
          <DualProgressBar
            leftValue={formatDecimals(postData?.layer3Data?.likeStakedSum)}
            rightValue={formatDecimals(postData?.layer3Data?.dislikeStakedSum)}
            rightContent={`${formatNumber(formatDecimals(postData?.layer3Data?.dislikeStakedSum))}`}
            leftContent={`${formatNumber(formatDecimals(postData?.layer3Data?.likeStakedSum))}`}
            leftLabel='Staked'
            rightLabel='Staked'
          />
        </>
      );

    case 'zora':
      return (
        <>
          <DualProgressBar
            leftValue={postData?.zoraData?.likeTotalVolumeSum}
            rightValue={postData?.zoraData?.dislikeTotalVolumeSum}
            leftContent={`$${formatNumber(formatDecimals(postData?.zoraData?.likeTotalVolumeSum))}`}
            rightContent={`$${formatNumber(formatDecimals(postData?.zoraData?.dislikeTotalVolumeSum))}`}
            leftLabel='Volume'
            rightLabel='Volume'
          />
          <DualProgressBar
            leftValue={postData?.zoraData?.likeCoinsCreatedSum || 0}
            rightValue={postData?.zoraData?.dislikeCoinsCreatedSum || 0}
            rightContent={postData?.zoraData?.dislikeCoinsCreatedSum || 0}
            leftContent={postData?.zoraData?.likeCoinsCreatedSum || 0}
            leftLabel='Coins Created'
            rightLabel='Coins Created'
          />
          <DualProgressBar
            leftValue={postData?.zoraData?.likeUniqueTokensSum}
            rightValue={postData?.zoraData?.dislikeUniqueTokensSum}
            rightContent={`${formatNumber(formatDecimals(postData?.zoraData?.dislikeUniqueTokensSum))}`}
            leftContent={`${formatNumber(formatDecimals(postData?.zoraData?.likeUniqueTokensSum))}`}
            leftLabel='Unique Tokens'
            rightLabel='Unique Tokens'
          />
        </>
      );
    default:
      return (
        <>
          <DualProgressBar
            leftValue={formatDecimals(postData?.sumLikesVol)}
            rightValue={formatDecimals(postData?.sumDislikesVol)}
            rightContent={`$${formatNumber(formatDecimals(postData?.sumDislikesVol))}`}
            leftContent={`$${formatNumber(formatDecimals(postData?.sumLikesVol))}`}
            leftLabel='Volume'
            rightLabel='Volume'
          />
        </>
      );
  }
}

const Voting = ({ postData }) => {
  return (
    <FlexboxColumn fw>
      <Flexbox justifyContent='space-between' fw>
        <ThemedText.H6>Supporters have</ThemedText.H6>
        <ThemedText.H6>Opposition has</ThemedText.H6>
      </Flexbox>
      <ProtocolVoting postData={postData} />
    </FlexboxColumn>
  );
};

export default Voting;
